import React from "react";

import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

const WorldCupMetricSummary = (props) => {
  const { data } = props;

  return (
    <div className="mt-2 row d-flex align-items-end">
      {data.comments && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Comments
          </Heading>
          <Metric {...data.comments} size={"md"} />
        </div>
      )}

      {data.reach && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Reach
          </Heading>
          <Metric {...data.reach} size={"md"} />
        </div>
      )}

      {data.published_posts && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Published Posts
          </Heading>
          <Metric {...data.published_posts} size={"md"} />
        </div>
      )}

      {data.engagement && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Engagements
          </Heading>
          <Metric {...data.engagements} size={"md"} />
        </div>
      )}

      {data.likes && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Likes
          </Heading>
          <Metric {...data.likes} size={"md"} />
        </div>
      )}

      {data.shares && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Shares
          </Heading>
          <Metric {...data.shares} size={"md"} />
        </div>
      )}

      {data.views && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Views
          </Heading>
          <Metric {...data.views} size={"md"} />
        </div>
      )}

      {data.saved && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Saves
          </Heading>
          <Metric {...data.saved} size={"md"} />
        </div>
      )}

      {data.comments && (
        <div className="mb-3 col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Total Comments
          </Heading>
          <Metric {...data.comments} size={"md"} />
        </div>
      )}
    </div>
  );
};

export default WorldCupMetricSummary;
